import { get } from './request'
import { serverApiUrl } from '../config/server';

/**
 * 获取统计信息
 * @param {string} typeId 类型id
 * @param {string} id 模块id
 * @returns {Promise<any>}
 */
export const typeStatistics = async (typeId,data) => {
    const res = await get(`${serverApiUrl}/type/${typeId}/TypeStatistics`,data);
    return res.data.data;
}

/**
 * 获取设备统计数据
 * @param {string} GroupId 
 * @param {object} data 
 * @returns {Promise<any>}
 */
export const deviceStatisticsData = async (GroupId, data) => {
    const res = await get(`${serverApiUrl}/${GroupId}/DeviceStatisticsData`, data);
    return res.data.data;
}

/**
 * 获取设备报警数据
 * @param {object} data 
 * @returns {Promise<any>}
 */
export const deviceWarnStatisticsData = async (data) => {
    const res = await get(`${serverApiUrl}/Warn`, data);
    return res.data.data;
}

/**
 * 获取设备离散型数据统计
 * @param {string} groupId 
 * @param {object} data 
 * @returns {Promise<any>}
 */
export const deviceDiscreteStatisticsData = async (groupId, data) => {
    try {
        const res = await get(`${serverApiUrl}/${groupId}/DeviceDiscreteStatistics`, data);
        return res.data.data;
    } catch (error) {
        console.log(error);


    }

}

/**
 * 根据数据定义或者报警编码获取数据
 * @param {object} data 
 * @returns 
 */
export const dataDefineWarnCode = async (data)=>{
    const res = await get(`${serverApiUrl}/DataDefineWarnCode`,data);
    return res.data.data;
}

/**
 * 获取报警统计
 * @returns any
 */
export const getWarnStatistics = async (data)=>{
    const res = await get(`${serverApiUrl}/Warn/statistics`,data);
    return res.data.data;
}